import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
IonicModule.forRoot()
import { AppRoutingModule } from './app-routing.module';
import { LoadMaterialModule } from './material-module';

import {
  AppComponent,
  AboutDialogComponent,
  AboutSplashDialogComponent,
  AboutLoginDialogComponent,
  AboutActionCompleteComponent,
  AboutDeleteComponent,
  AboutStudyDeleteComponent,
  AboutElevationDeleteComponent,
  AddStudyComponent,
  AddElevationComponent,
} from './app.component';
import { MenuComponent } from './menu/menu.component';
import { MapComponent } from './map/map.component';
import { TableComponent } from './table/table.component';
import { PrintComponent } from './print/print.component';
import { MonitoringService } from './monitoring.service';
import { MonitoringErrorHandler } from './error.handler';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    AppComponent,
    AboutDialogComponent,
    AboutSplashDialogComponent,
    AboutLoginDialogComponent,
    AboutActionCompleteComponent,
    AboutDeleteComponent,
    AboutStudyDeleteComponent,
    AboutElevationDeleteComponent,
    AddStudyComponent,
    AddElevationComponent,
    MenuComponent,
    MapComponent,
    TableComponent,
    PrintComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    LoadMaterialModule,
    CommonModule,
    MatDialogModule,
    IonicModule.forRoot()
  ],
  exports: [LoadMaterialModule],
  providers: [
    MonitoringService,
    {
      provide: ErrorHandler,
      useClass: MonitoringErrorHandler,
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
